import React, { useMemo, useState, useCallback } from 'react';
import styles from './index.module.scss';
import cn from 'classnames';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';

import { LABEL, CUSTOM_MESSAGES } from '@veriables';
import FullWidthModal from '@components/common/Modal/FullWidthModal';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';
import { TouchableButton } from '@components/common/Touchable/index';
import ModalHeader from '@components/common/ModalHeader/index';
import {setErrorPopUp } from '@reducers/notification';

const OpenPriceModal = ({ isOpenPricePopup, handleClosePopup, count, setCount, inputValue, setInputValue, onSubmit, validatePrice, ...props }) => {
    const { serverAppTheme, setErrorPopUp} = props; // Redux imports
    // const [inputValue, setInputValue] = useState('');

    const validateGiftCardMaxAmount = () => {
        const isGiftCard = props.selectedMenuItem?.menuItem?.cardType === 2;
        if (!isGiftCard) {
            return true;
        }

        const giftCardSaleInfo = props.auth?.giftCardSaleInfo;
        const maxCardAmount = giftCardSaleInfo?.maxCardAmount;
        if (!giftCardSaleInfo || !maxCardAmount) {
            return true;
        }

        const enteredValue = parseFloat(inputValue);
        if (isNaN(enteredValue) || enteredValue <= 0) {
            setErrorPopUp({
                res: 'Please enter a valid amount',
                noErrorTxt: true
            });
            return false;
        }
        if (enteredValue > maxCardAmount) {
            setErrorPopUp({
                res: `Cannot purchase gift card for more than $${maxCardAmount.toFixed(2)}`,
                noErrorTxt: true
            });
            return false;
        }
        return true;
    };

    const popupModal = useMemo(() => {
        const modalStyle = {
            backgroundColor: serverAppTheme?.popUp_bg,
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
            width: '100%',
            height: "100%",
            fontFamily: 'Poppins',
            margin: 'auto'
        }
        const parentContainer = { color: serverAppTheme?.primary_text }
        const inputStyle = {
            fontSize: "2rem",
            height: '12.4vh',
            textAlign: 'initial',
            borderRadius: '0',
            background: serverAppTheme?.inputBg,
            borderBottom: serverAppTheme?.inputBorder_Bottom,
            color: serverAppTheme?.primary_text,
            '--placeholder-color': serverAppTheme?.input_placeholder
        }
        const buttonStyle = {
            backgroundColor: serverAppTheme?.secondaryBtn,
            color: serverAppTheme?.btn_font_color,
            borderRadius: '8px'
        }

        return { modalStyle, parentContainer, inputStyle, buttonStyle }
    }, [serverAppTheme])

    const handleBlur = () => {
        const element = document.querySelector('#input');
        if (element) element.blur();
    };

    const onClickBtn = useCallback(e => {
        setInputValue(prev =>
            e === '{bksp}' ? prev.slice(0, -1) : prev.concat(e)
        );
    }, []);

    return (
        <FullWidthModal isOpen={isOpenPricePopup} loading={props.loading} style={popupModal.modalStyle} customClass='h-100 w-100'
            customClass2='h-100 w-100'>
            <div className={cn("col-12 px-0 h-100 d-flex flex-column align-items-center position-relative text-center",)} style={popupModal.parentContainer}>
                <ModalHeader
                    isTab={!!props.seat?.tab}
                    stationName={props.seat?.stationName || ''}
                    tileHeader={LABEL().OPEN_PRICE}
                    seatNumber={props.seat?.number}
                />
                <div className="fs_18 fw-600 text-center pt-2 pb-2">{CUSTOM_MESSAGES().OPEN_PRICE_TITLE}</div>

                <div className={cn('text-center', styles.formContainer, 'col-8 p-0 ')}>
                    <Formik
                        initialValues={{ price: '' }}
                        onSubmit={onSubmit}
                        validate={validatePrice}
                    >
                        {() => {
                            return (
                                <Form>
                                    <div className={cn('col-12 fs-20 large-input row mx-0 p-0 justify-content-between')}>
                                        <div className="col-8 d-flex px-0">
                                            <div>
                                                <input
                                                    name="price"
                                                    value={inputValue}
                                                    className={cn('form-control fw-400', styles.inputBg)}
                                                    type="text"
                                                    style={popupModal.inputStyle}
                                                    id="input"
                                                    onFocus={() => { handleBlur(); }}
                                                    placeholder="Enter Price"
                                                    erase
                                                />
                                                {inputValue?.length > 0 && (
                                                    <div
                                                        className={cn("text-right", styles.formCrossIcon)}
                                                        role="presentation"
                                                        onClick={() => setInputValue('')}
                                                    >
                                                        <Cross alt='back' fill={serverAppTheme?.iconcolor} aria-hidden="true" />
                                                    </div>
                                                )}
                                                <div
                                                    className='col-12 px-0 text-right error fs-14 fw-400'
                                                    style={{ height: '1.5rem' }}
                                                >
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-3 d-flex px-0 pb-25 align-items-center mr-0">
                                            <TouchableButton
                                                className={cn(styles.incDecButton, 'rounded mr-2')}
                                                style={{
                                                    background: serverAppTheme?.primaryBtn,
                                                    color: serverAppTheme?.btn_font_color,
                                                }}
                                                type="button"
                                                onClick={() => count > 1 && setCount(count - 1)}
                                                disabled={count <= 1}
                                                aria-label="minusCartQtyBtn"
                                            >
                                                {/* Replacing text to svg by #Rahul */}
                                                {/* - */}
                                                <i className="fas fa-minus justify-content-center align-items-center" />
                                            </TouchableButton>
                                            <div
                                                className="fs_24 fw-700 d-flex align-items-center mx-2"
                                                style={{ color: serverAppTheme?.primary_text, width: '15px' }}
                                            >
                                                {count}
                                            </div>
                                            <TouchableButton
                                                className={cn(styles.incDecButton, 'rounded ml-2')}
                                                style={{
                                                    background: serverAppTheme?.primaryBtn,
                                                    color: serverAppTheme?.btn_font_color,
                                                }}
                                                type="button"
                                                onClick={() => setCount(count + 1)}
                                                aria-label="plusCartQtyBtn"
                                            >
                                                {/* Replacing text to svg by #Rahul */}
                                                <i className="fas fa-plus justify-content-center align-items-center" />
                                                {/* + */}
                                            </TouchableButton>
                                        </div>
                                    </div>
                                    <CustomKeyboard
                                        onClickBtn={onClickBtn}
                                        type='withoutDone'
                                        typed={inputValue}
                                        btnSize={'btn35'}
                                        isDot
                                        isDiscount
                                        customClass={'fs-20'}
                                        isPaymentApp={false}
                                        isDecimal
                                        screenType='openDollarPopUp'
                                    />
                                    <div className='d-flex col-12 px-0 mt-3'>
                                        <div className='col-6 pl-0 pr-1'>
                                            <TouchableButton type="button" className={cn('px-0 pl-2 rounded btn-ripple fs_24 fw-600 w-100 btn44')} onClick={(e) => { handleClosePopup(); setInputValue(''); e.preventDefault(); }} style={{ backgroundColor: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font }}>
                                                {LABEL().CANCEL}
                                            </TouchableButton>
                                        </div>
                                        <div className='col-6 pr-0 pl-1'>
                                            <button
                                                className={cn(
                                                    'w-100 btn44',
                                                )}
                                                type="submit"
                                                style={popupModal.buttonStyle}
                                                onClick={(e) => {
                                                    if (!inputValue && setErrorPopUp) {
                                                        e.preventDefault();
                                                        const validationResult = validatePrice({ price: inputValue });
                                                        if (validationResult?.price && setErrorPopUp) {
                                                            setErrorPopUp({
                                                                res: validationResult.price,
                                                                noErrorTxt: true
                                                            });
                                                        }
                                                    } else if (inputValue) {
                                                        if (!validateGiftCardMaxAmount()) {
                                                            e.preventDefault();
                                                        }
                                                    }
                                                }}
                                            >
                                                <div className="fs_24 fw-600 text-white">{LABEL().ADD_TO_CART}</div>
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            );
                        }}
                    </Formik>
                </div>
            </div>
        </FullWidthModal>
    )
}

const mapStateToProps = ({ theme, orders }) => {
    return {
        serverAppTheme: theme.serverAppTheme,
        seat: orders?.seats ?? {},
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setErrorPopUp
}, dispatch);

const MemoizedOpenPriceModal = React.memo(OpenPriceModal);

export default connect(mapStateToProps, mapDispatchToProps)(MemoizedOpenPriceModal);